"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const SlideShow_1 = __importDefault(require("./DSLinearPages/SlideShow"));
const DailyViewPage_1 = __importDefault(require("./DailyViewPage"));
const DSInteractiveMainPage_1 = __importDefault(require("./DSInteractiveMainPage"));
const Overview = (props) => {
    const isLinear = props.mode === 'linear';
    const isDailyView = props.mode === 'daily_view';
    const showOldLinear = window.location.search.includes('showOldLinear=true');
    if (isDailyView) {
        return react_1.default.createElement(DailyViewPage_1.default, { brandInfo: props.brandInfo });
    }
    return isLinear && !showOldLinear ? react_1.default.createElement(SlideShow_1.default, null) : react_1.default.createElement(DSInteractiveMainPage_1.default, null);
};
const mapStoreToProps = store => ({
    brandInfo: store.getValue('brandSettings'),
    mode: store.getValue('mode'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Overview);
